// extracted by mini-css-extract-plugin
export default {"navigationLink":"NavigationLink_navigationLink__PGDJw"};